<div class="application-stage-component">
  <div class="application-stage {{toClass()}} {{toClass()}}-border" fxLayout="row" fxLayoutAlign="space-between center">
    <span class="mdi mdi-{{stageIcon()}} stage-icon"></span>
    <span class="stage-name">{{stage}}</span>
    <span class="mdi mdi-arrow-top-right hidden-icon"></span>
  </div>
</div>
